import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import AuthCallback from "./components/AuthCallback";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Onboarding from "./pages/Onboarding";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import Recommendation from "./pages/Recommendation";
import MyWorld from "./pages/MyWorld";
import Trips from "./pages/Trips";
import Profile from "./pages/Profile";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminRetention from "./pages/admin/AdminRetention";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminUserDetail from "./pages/admin/AdminUserDetail";
import AdminDestinations from "./pages/admin/AdminDestinations";
import AdminAudit from "./pages/admin/AdminAudit";

function AppRouter() {
    const location = useLocation();
    // Process OAuth callback synchronously to avoid AuthProvider race conditions
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requireBirth><Dashboard /></ProtectedRoute>} />
            <Route path="/recommendation/:id" element={<ProtectedRoute requireBirth><Recommendation /></ProtectedRoute>} />
            <Route path="/world" element={<ProtectedRoute requireBirth><MyWorld /></ProtectedRoute>} />
            <Route path="/trips" element={<ProtectedRoute requireBirth><Trips /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/admin" element={<AdminRoute><AdminOverview /></AdminRoute>} />
            <Route path="/admin/overview" element={<AdminRoute><AdminOverview /></AdminRoute>} />
            <Route path="/admin/retention" element={<AdminRoute><AdminRetention /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
            <Route path="/admin/users/:user_id" element={<AdminRoute><AdminUserDetail /></AdminRoute>} />
            <Route path="/admin/destinations" element={<AdminRoute><AdminDestinations /></AdminRoute>} />
            <Route path="/admin/audit" element={<AdminRoute><AdminAudit /></AdminRoute>} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ThemeProvider>
                    <AuthProvider>
                        <AppRouter />
                    </AuthProvider>
                </ThemeProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
